module.exports = __webpack_public_path__ + "static/media/30.66df8ebe.jpg";